import Tree, { TreeNode } from "../../sharedComponents/tree/PrimeTree";
import classNames from "classnames/bind";
import classes from "./HierarchiesTreeCard.module.scss";
import { Card, MenuButton, Modal } from "@velocity-ehs/component-library";
import Select from "../../sharedComponents/inputs/Select";
import { MenuItem } from "primereact/menuitem";
import {
  TreeEventNodeEvent,
  TreeExpandedKeysType,
  TreeExpandedEvent,
  TreeMultipleSelectionKeys,
  TreeCheckboxSelectionKeys,
} from "primereact/tree";
import { useTranslation } from "react-i18next";

interface HierarchiesTreeCardProps {
  nodes: TreeNode[];
  options: any;
  selectedOption: any;
  updateSelectedOption: any;
  expandedKeys: TreeExpandedKeysType;
  selected:
    | string
    | TreeMultipleSelectionKeys
    | TreeCheckboxSelectionKeys
    | null;
  handleRowClick(e: TreeEventNodeEvent): void;
  handleExpanderClick(e: TreeEventNodeEvent): void;
  handleOnToggle(e: TreeExpandedEvent): void;
  isLoading: boolean;
  openHierarchySlider: (e: boolean) => void;
  isDeleteModalOpen: boolean;
  closeDeleteModal: () => void;
  onDeleteHierarchy: () => void;
  isDeleting: boolean;
  openDeleteModal: () => void;
}

const HierarchiesTreeCard = ({
  nodes,
  options,
  selectedOption,
  updateSelectedOption,
  expandedKeys,
  selected,
  handleRowClick,
  handleExpanderClick,
  handleOnToggle,
  isLoading,
  openHierarchySlider,
  isDeleteModalOpen,
  closeDeleteModal,
  onDeleteHierarchy,
  isDeleting,
  openDeleteModal,
}: HierarchiesTreeCardProps): React.ReactElement => {
  const cx = classNames.bind(classes);
  const { t } = useTranslation();
  const actionButtons = (): Array<MenuItem> => {
    return [
      {
        label: t("hierarchies_Rename"),
        command: () => openHierarchySlider(true),
      },
      {
        label: t("universal_Delete"),
        command: () => openDeleteModal(),
      },
    ];
  };

  const card = (
    <Card
      title={t("hierarchies_Org_Hierarchies")}
      headerAction={
        <MenuButton
          label={t("universal_Actions")}
          items={actionButtons()}
          buttonClass="p-button-text"
          icon="pi-chevron-down"
        />
      }
    >
      <div className={classes.cardContent}>
        <Select
          key={selectedOption?.name}
          name="Hierarchy Name"
          className={cx(classes.hierarchySelect)}
          options={options}
          value={selectedOption}
          display="name"
          required={false}
          onChange={updateSelectedOption}
          label={t("action_select_hierarchy")}
          placeholder={t("hierarchies_hierarchy_name")}
        />
        {selectedOption && selectedOption.topOrgUnit ? (
          <Tree
            expandedKeys={expandedKeys}
            nodes={nodes as TreeNode[]}
            selectionKeys={selected}
            onSelect={handleRowClick}
            onExpand={handleExpanderClick}
            onToggle={handleOnToggle}
            loading={isLoading}
          />
        ) : (
          <div className={cx(classes.noOrgMessage)}>
            <p className={cx(classes.emphasis)}>
              {t("hierarchies_No_Org_Associated_Text")}
            </p>
            <p>{t("message_add_button")}</p>
          </div>
        )}
        {options && options.length === 0 && (
          <>
            <p className={cx(classes.topInfo)}>
              {t("message_org_hierarchies_arrange_locations")}
            </p>
            <p>{t("message_org_hierarchies_roles_permissions")}</p>
          </>
        )}
      </div>
    </Card>
  );

  return (
    <>
      {card}
      <Modal
        title={t("action_delete_hierarchy")}
        show={isDeleteModalOpen}
        onClose={closeDeleteModal}
        footerButtons={[
          {
            label: t("universal_Delete"),
            onClick: onDeleteHierarchy,
            loading: isDeleting,
            id: "deleteHierarchyModal",
          },
          {
            label: t("universal_Cancel"),
            className: "p-button-text",
            onClick: closeDeleteModal,
            id: "cancelDeleteHierarchyModal",
          },
        ]}
      >
        {t("message_deleting_hierarchy")}
      </Modal>
    </>
  );
};

export default HierarchiesTreeCard;
